import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { ISelectValuePopupComponentData, ISelectValuePopupComponentResult } from './interfaces';

@Component({
    templateUrl: 'select-value-popup.component.html',
    standalone: false
})
export class SelectValuePopupComponent {
    value = '';

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: ISelectValuePopupComponentData,
        private matDialogRef: MatDialogRef<SelectValuePopupComponent, ISelectValuePopupComponentResult>
    ) {
    }

    onClose(): void {
        this.matDialogRef.close();
    }

    onOK(): void {
        const result: ISelectValuePopupComponentResult = { selectedValue: this.value };
        this.matDialogRef.close(result);
    }
}
